
export const jiraWebhooksToDeleteTasks = ({ jiraWebhooks, currentAccountMapping, otherConnectedAccountsIds }) => {
  const { id: currentAccountMappingId } = currentAccountMapping;

  const result = {};
  const addResult = (key, { info = '', webhook, jql, events }) => {
    while (result[key]) key = `dup_${key}`;
    if (key.startsWith('dup_')) info = `(Duplicate) ${info}`;
    result[key] = {
      key,
      deleteTask: {
        type: 'jira',
        action: 'delete',
        info,
        webhook,
        jql,
        events,
      }
    };
  };

  // eslint-disable-next-line no-unused-vars
  for (const w of jiraWebhooks.filter(w => (w.name || '').startsWith('PagerDuty_managed_'))) {
    const {
      name = '',
      filters = {},
      events = [],
      url = '',
      self,
      // the following only exist in Jira 10+:
      id,
      configuration = {},
    } = w;

    const [, search = ''] = url.split('?');
    const urlParams = new URLSearchParams(search);
    const ruleId = urlParams.get('rule_id');
    const accountsMappingId = urlParams.get('accounts_mapping_id');
    const signature = urlParams.get('signature');
    const jql = configuration.FILTERS || filters['issue-related-events-section'] || '';
    const webhookId = id || self.split('/').reverse()[0];

    const webhook = {
      id: webhookId,
    };

    if (!ruleId || !accountsMappingId || !signature) {
      addResult(`invalid_url_${name}`, { info: `Invalid URL or query params ${url}`, webhook, jql, events });
      continue;
    }

    // filter out webhooks from other allowed accounts mappings
    if (otherConnectedAccountsIds.some(id => name.startsWith(`PagerDuty_managed_${id}`) && accountsMappingId === id)) {
      continue;
    }

    if (!name.startsWith(`PagerDuty_managed_${currentAccountMappingId}_`) || accountsMappingId !== currentAccountMappingId) {
      addResult(`invalid_name_${name}`, { info: 'There is no PagerDuty account using this webhook', webhook, jql, events });
      continue;
    }

    const key = `jira_${(events || []).sort().join(',')}_${jql}_${accountsMappingId}_${ruleId}`;
    addResult(key, { webhook, jql, events });
  }

  return result;
};
